import { render } from "./student.vue?vue&type=template&id=4ce1ff41&ts=true"
import script from "./student.vue?vue&type=script&lang=ts"
export * from "./student.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__